import React, { useState } from "react";
import PropTypes from "prop-types";
import { generateRequestAISummary } from "../../../../api/t2tRequestsApi";

export default function AISummaryBlock({ requestId, existingSummary, onSummaryGenerated }) {
  const [summary,     setSummary]     = useState(existingSummary || "");
  const [generating,  setGenerating]  = useState(false);
  const [error,       setError]       = useState("");

  const handleGenerate = async () => {
    setGenerating(true);
    setError("");
    try {
      const res = await generateRequestAISummary(requestId);
      const text = res?.data?.data?.ai_summary || "";
      setSummary(text);
      if (onSummaryGenerated) onSummaryGenerated(text);
    } catch (e) {
      setError(e.message || "Failed to generate summary");
    } finally {
      setGenerating(false);
    }
  };

  return (
    <div
      style={{
        background: "linear-gradient(135deg, rgba(42,99,234,0.06) 0%, var(--t2t-surface) 100%)",
        border: "1px solid rgba(42,99,234,0.18)",
        borderRadius: "var(--t2t-radius)",
        padding: "12px 14px",
        marginBottom: 14,
      }}
    >
      <div className="d-flex align-items-center justify-content-between" style={{ marginBottom: 8 }}>
        <span className="d-flex align-items-center gap-2" style={{ fontSize: 13, fontWeight: 600, color: "var(--t2t-text-primary)" }}>
          <i className="bi bi-stars" style={{ color: "var(--t2t-primary)", fontSize: 14 }} />
          AI Summary
        </span>
        <button
          className="t2t-btn t2t-btn-outline t2t-btn-sm d-flex align-items-center gap-1"
          onClick={handleGenerate}
          disabled={generating}
          title={summary ? "Regenerate summary" : "Generate summary"}
        >
          <i className={`bi bi-arrow-clockwise${generating ? " t2t-spin" : ""}`} style={{ fontSize: 11 }} />
          {summary ? "Regenerate" : "Generate"}
        </button>
      </div>

      {error && (
        <p style={{ fontSize: 12, color: "var(--t2t-danger)", margin: 0 }}>{error}</p>
      )}

      {!error && !summary && !generating && (
        <p style={{ fontSize: 12, color: "var(--t2t-text-muted)", fontStyle: "italic", margin: 0 }}>
          Click Generate to create an AI summary of this request.
        </p>
      )}

      {generating && !summary && (
        <p style={{ fontSize: 12, color: "var(--t2t-text-muted)", fontStyle: "italic", margin: 0 }}>
          Generating summary…
        </p>
      )}

      {summary && (
        <p style={{ fontSize: 13, lineHeight: 1.6, color: "var(--t2t-text-primary)", margin: 0 }}>
          {summary}
        </p>
      )}
    </div>
  );
}

AISummaryBlock.propTypes = {
  requestId:          PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  existingSummary:    PropTypes.string,
  onSummaryGenerated: PropTypes.func,
};
